import { render, staticRenderFns } from "./SidebarLeft.vue?vue&type=template&id=26642b80&scoped=true&"
import script from "./SidebarLeft.vue?vue&type=script&lang=js&"
export * from "./SidebarLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26642b80",
  null
  
)

export default component.exports